import api from './axios';

export const getCartApi        = ()           => api.get('/cart');
export const addToCartApi      = (data)       => api.post('/cart/items', data);
export const updateCartItemApi = (id, data)   => api.put(`/cart/items/${id}`, data);
export const removeCartItemApi = (id)         => api.delete(`/cart/items/${id}`);
export const clearCartApi      = ()           => api.delete('/cart');
export const applyCouponApi    = (data)       => api.post('/cart/coupon', data);
